import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';

import store from './store';

// CSS
import './css/fonts.css';
import './css/buttons.css';
import './css/colors.css';
import './css/helpers.css';
import './css/layout.css';
import 'bootstrap/dist/css/bootstrap.css';
import './css/animations.css';
import './css/responsiveness.css';
import 'react-select/dist/react-select.css';
import "animate.css/animate.min.css";

// Apps
import App_Public from './apps/App.Public';
import App_Admin from './apps/App.Admin';

// Common
import About from './components/information/about';
import Alumni from './components/alumni';
import CS from './components/home';
import CompOrRec from './components/information/comp_rec';
import Contact from './components/contact';
import Covid from './components/covid';
import Express from './components/information/express';
import Rules from './components/information/rules';
import Gallery from './components/gallery';
import GeneralInformation from './components/information';
import Hotels from './components/hotels';
import Kitchen from './components/examples/kitchen';
import FAQs from './components/faqs';
import Privacy from './components/information/privacy';
import Rankings from './components/rankings';
import Passport from './components/information/passport';
import Tournaments from './components/tournaments';
import PastTournaments from './components/tournaments/past';
import Tournament from './components/tournaments/tournament';
import Tournament_Rules from './components/tournaments/rules';
import Tournament_Entries from './components/tournaments/entries';
import Tournament_Rankings from './components/tournaments/rankings';
import Login from './components/private/login';
import Weather from './components/information/weather';
import WhatsNew from './components/information/new';

import Admin_Alumni from './components/private/alumni';
import Admin_Alumni_Add from './components/private/alumni/add';
import Admin_Dashboard from './components/private/dashboard/';
import Admin_Tournaments_Add from './components/private/tournaments/add';
import Admin_Tournaments from './components/private/tournaments';
import Admin_Affiliates_Add from './components/private/affiliates/add';
import Admin_Affiliates from './components/private/affiliates';
import Admin_Medals from './components/private/medals';
import Admin_Medals_Add from './components/private/medals/add';
import Admin_Sponsors from './components/private/sponsors';
import Admin_Sponsors_Add from './components/private/sponsors/add';
import Admin_QAS from './components/private/qas/index';
import Admin_QAS_Add from './components/private/qas/add';
import Admin_Hotels from './components/private/hotels';
import Admin_Hotels_Add from './components/private/hotels/add';

import Admin_Contact from './components/private/contact/index';
//import Admin_Contact_Add from './components/private/contact/add';

// Help
import fakeAuth from './fakeAuth';

const history = syncHistoryWithStore(browserHistory, store)

function requireAuth(nextState, replace) {
  if (!fakeAuth.isAuthenticated()) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    })
    return;
  }
}

class Root extends React.Component {
  render() {
    return (
      <Provider store={store}>
        { /* SITEMAP? */}
        <Router history={history}>
          { /* Family Site */}
          <Route path="/" component={App_Public}>
            <IndexRoute component={CS} />
            <Route path="/kitchen" component={Kitchen} />
            <Route path="/new" component={WhatsNew} />
            <Route path="/information" component={GeneralInformation} />
            <Route path="/gallery" component={Gallery} />
            <Route path="/passport" component={Passport} />
            <Route path="/rankings" component={Rankings} />
            <Route path="/rankings/:gender" component={Rankings} />
            <Route path="/hotels/:id" component={Hotels} />
            <Route path="/tournaments" component={Tournaments} />
            <Route path="/tournaments/past" component={PastTournaments} />
            <Route path="/tournament/:id" component={Tournament} />
            <Route path="/tournament/:id/rules" component={Tournament_Rules} />
            <Route path="/tournament/:id/entries" component={Tournament_Entries} />
            <Route path="/tournament/:id/rankings" component={Tournament_Rankings} />
            <Route path="/faqs" component={FAQs} />
            <Route path="/about" component={About} />
            <Route path="/alumni" component={Alumni} />
            <Route path="/express" component={Express} />
            <Route path="/rules" component={Rules} />
            <Route path="/comp_or_rec" component={CompOrRec} />
            <Route path="/divisions" component={CompOrRec} />
            <Route path="/contact" component={Contact} />
            <Route path="/weather" component={Weather} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/covid" component={Covid} />
          </Route>
          <Route path="/admin" component={App_Admin}>

            <IndexRoute component={Login} />
            <Route path="/admin/dashboard" component={Admin_Dashboard} onEnter={requireAuth} />

            <Route path="/admin/tournaments/add/:id" component={Admin_Tournaments_Add} onEnter={requireAuth} />
            <Route path="/admin/tournaments/add" component={Admin_Tournaments_Add} onEnter={requireAuth} />
            <Route path="/admin/tournaments" component={Admin_Tournaments} onEnter={requireAuth} />

            <Route path="/admin/affiliates/add/:id" component={Admin_Affiliates_Add} onEnter={requireAuth} />
            <Route path="/admin/affiliates/add" component={Admin_Affiliates_Add} onEnter={requireAuth} />
            <Route path="/admin/affiliates" component={Admin_Affiliates} onEnter={requireAuth} />

            <Route path="/admin/medals/add/:id" component={Admin_Medals_Add} onEnter={requireAuth} />
            <Route path="/admin/medals/add" component={Admin_Medals_Add} onEnter={requireAuth} />
            <Route path="/admin/medals" component={Admin_Medals} onEnter={requireAuth} />

            <Route path="/admin/sponsors/add/:id" component={Admin_Sponsors_Add} onEnter={requireAuth} />
            <Route path="/admin/sponsors/add" component={Admin_Sponsors_Add} onEnter={requireAuth} />
            <Route path="/admin/sponsors" component={Admin_Sponsors} onEnter={requireAuth} />

            <Route path="/admin/qas/add/:id" component={Admin_QAS_Add} onEnter={requireAuth} />
            <Route path="/admin/qas/add" component={Admin_QAS_Add} onEnter={requireAuth} />
            <Route path="/admin/qas" component={Admin_QAS} onEnter={requireAuth} />

            <Route path="/admin/contact" component={Admin_Contact} onEnter={requireAuth} />

            <Route path="/admin/alumni/add/:id" component={Admin_Alumni_Add} onEnter={requireAuth} />
            <Route path="/admin/alumni/add" component={Admin_Alumni_Add} onEnter={requireAuth} />
            <Route path="/admin/alumni" component={Admin_Alumni} onEnter={requireAuth} />

            <Route path="/admin/hotels/add/:id" component={Admin_Hotels_Add} onEnter={requireAuth} />
            <Route path="/admin/hotels/add" component={Admin_Hotels_Add} onEnter={requireAuth} />
            <Route path="/admin/hotels" component={Admin_Hotels} onEnter={requireAuth} />
          </Route>
          <Route path="*" component={App_Public}>
            <IndexRoute component={CS} />
          </Route>
        </Router>
      </Provider>
    )
  }
}

render(<Root />, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js